import { h5Enabled, initH5GamesAds, showH5BreakAd } from './h5GamesAd'
import {
  claimBreakSlot,
  initMonetagVignette,
  markBreakShown,
  openMonetagAd,
} from './monetagAd'

export { noteRoundEnded } from './monetagAd'

export function initBreakAds(): void {
  if (h5Enabled) {
    initH5GamesAds()
    return
  }
  initMonetagVignette()
}

export function showBreakAd(onDone: () => void): void {
  if (!claimBreakSlot()) {
    onDone()
    return
  }

  if (h5Enabled) {
    showH5BreakAd(markBreakShown, onDone)
    return
  }

  openMonetagAd()
  onDone()
}
